import { type CSSProperties, type RefObject, useEffect, useState } from 'react'

const FADE = '32px'

/** A mask that dissolves whichever edge of a scroller has content running under it. */
export function useScrollEdgeFade(ref: RefObject<HTMLElement | null>): CSSProperties | undefined {
  const [edges, setEdges] = useState({ top: false, bottom: false })

  useEffect(() => {
    const node = ref.current
    if (!node) return
    const update = () =>
      setEdges({
        top: node.scrollTop > 4,
        bottom: node.scrollHeight - node.scrollTop - node.clientHeight > 4,
      })
    update()
    node.addEventListener('scroll', update, { passive: true })
    // The content grows as messages land, which resizes the child rather than the scroller.
    const resize = new ResizeObserver(update)
    resize.observe(node)
    if (node.firstElementChild) resize.observe(node.firstElementChild)
    return () => {
      node.removeEventListener('scroll', update)
      resize.disconnect()
    }
  }, [ref])

  if (!edges.top && !edges.bottom) return undefined
  const mask = `linear-gradient(to bottom, ${edges.top ? `transparent 0, #000 ${FADE}` : '#000 0'}, ${
    edges.bottom ? `#000 calc(100% - ${FADE}), transparent 100%` : '#000 100%'
  })`
  return { maskImage: mask, WebkitMaskImage: mask }
}
